import { render, staticRenderFns } from "./templateTypeManagement.vue?vue&type=template&id=5a3c9248&scoped=true&"
import script from "./templateTypeManagement.vue?vue&type=script&lang=js&"
export * from "./templateTypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c9248",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3c9248')) {
      api.createRecord('5a3c9248', component.options)
    } else {
      api.reload('5a3c9248', component.options)
    }
    module.hot.accept("./templateTypeManagement.vue?vue&type=template&id=5a3c9248&scoped=true&", function () {
      api.rerender('5a3c9248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/templateTypeManagement.vue"
export default component.exports